// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__18891","select":"styles_select__2uzp5"};